import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FeatureFlagService } from '@core/feature';
import { SdModal } from '@sdvor/shared/ui/v2';
import { QRCodeComponent } from 'angularx-qrcode';
import { UpdateQrButtonComponent } from '../update-qr-button';

@Component({
  selector: 'sd-loyalty-qr-modal',
  imports: [QRCodeComponent, UpdateQrButtonComponent, AsyncPipe],
  templateUrl: './loyalty-qr-modal.component.html',
  styleUrls: ['./loyalty-qr-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoyaltyQrModalComponent {
  @Input() qrCode = '';
  private readonly featureFlagService = inject(FeatureFlagService);
  protected readonly useNewQrEnableFlag$ = this.featureFlagService.isEnabled('useNewQrEnableFlag');

  constructor(private modal: SdModal) {}

  close(): void {
    this.modal.close();
  }
}
